import { codeInit } from 'redux/reducers/init';
import {
  requestCodeList,
  requestCodeListFailure,
  requestCodeListSuccess,
} from 'redux/actions/actions';

import { createReducer } from '@reduxjs/toolkit';
import CodeVO from 'commons/vo/CodeVO';

const code = createReducer(codeInit, {
  [requestCodeList.type]: (state, action) => {
    state.isLoading = true;
  },
  [requestCodeListSuccess.type]: (state, action) => {
    const {
      videoTypeList,
      wkblGameTypeList,
      kfScriptRefRangeList,
      wkblSeasonList,
      kfScriptTypeList,
    } = action.payload;
    state.isLoading = false;

    state.isInit = true;
    state.isLoading = false;
    state.videoTypeList = videoTypeList;
    state.wkblGameTypeList = wkblGameTypeList;

    const wkblDateGameTypeList = wkblGameTypeList.filter((gameType: CodeVO) => {
      // const regExp = /SEASON/gi;
      const regExp = /^SEASON/gi;
      return regExp.test(gameType.codevalue);
    });
    const wkblSpecialGameTypeList = wkblGameTypeList.filter((gameType: CodeVO) => {
      // const regExp = /ETC/gi;
      const regExp = /^ETC/gi;
      return regExp.test(gameType.codevalue);
    });

    state.wkblDateGameTypeList = wkblDateGameTypeList;
    state.wkblSpecialGameTypeList = wkblSpecialGameTypeList;

    state.kfScriptRefRangeList = kfScriptRefRangeList;
    state.wkblSeasonList = wkblSeasonList;
    state.kfScriptTypeList = kfScriptTypeList;
  },
  [requestCodeListFailure.type]: (state, action) => {
    state.isLoading = false;
    state.isInit = false;
    state.videoTypeList = [];
    state.wkblGameTypeList = [];
    state.kfScriptRefRangeList = [];
    state.wkblSeasonList = [];
    state.kfScriptTypeList = [];
  },
});

export default code;
